// extracted by mini-css-extract-plugin
export default {"logoContainer":"Logo_logoContainer__zupNO","logoImg":"Logo_logoImg__YcJCs"};